// extracted by mini-css-extract-plugin
export var blockedMessage = "_bd-3";
export var blockedOverlay = "_bd-1";
export var fadeIn = "_bd-2";
export var hereLink = "_bd-0";
export var slideUp = "_bd-4";